import { Navigate } from 'react-router-dom';
import FuseUtils from '../../@fuse/utils';
import FuseLoading from '../../@fuse/core/FuseLoading';
import settingsConfig from './settingsConfig';
import CreateDocument from '../main/repositorio/documents/create_document';
import SignInConfig from '../main/sign-in/SignInConfig';
import SignUpConfig from '../main/sign-up/SignUpConfig';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import Error404Page from '../main/404/Error404Page';
import DashboardConfig from '../main/example/DashboardConfig';
import MesaServicioConfig from '../main/mesa_servicio/MesaServicioConfig';
import MesaServicioReportesConfig from '../main/mesa_servicio_reportes/MesaServicioReportesConfig';
import MonitoreoConfig from '../main/monitoreo/MonitoreoConfig';
import ReportesConfig from '../main/reportes/ReportesConfig';
import RepositorioConfig from '../main/repositorio/RepositorioConfig';
import NivelesServicioConfig from '../main/niveles_servicio/NivelesServicioConfig';
import Dashboard from '../main/dashboard/dashboard';
import TopologicaConfig from '../main/topologica/TopologicaConfig';
import InterconectadosConfig from '../main/interconectados/InterconectadosConfig';
import AutoDescubrimientoConfig from '../main/autodescubrimiento/AutoDescubrimientoConfig';
import AdministracionConfig from '../main/administracionNivelesServicio/AdministracionConfig';
import TicketsConfig from '../main/tickets/TicketsConfig';
import TiposConsumoConfig from '../main/catalogos/tiposConsumo/TiposConsumoConfig';
import NodosConfig from '../main/catalogos/nodos/NodosConfig';
import SitiosConfig from '../main/catalogos/sitios/SitiosConfig';
import EntidadConfig from '../main/catalogos/entidad/EntidadConfig';
import TipoInmuebleConfig from '../main/catalogos/tipoInmueble/TipoInmuebleConfig';
import RegionConfig from '../main/catalogos/region/RegionConfig';
import GrupoInmuebleConfig from '../main/catalogos/grupoInmueble/GrupoInmuebleConfig';
import InmuebleConfig from '../main/catalogos/inmueble/InmuebleConfig';
import UmbralConfig from '../main/catalogos/umbral/UmbralConfig';
import CreateDocumentConfig from '../main/repositorio/documents/create_document/CreateDocumentConfig';
import UsuariosConfig from '../main/administracionUsuarios/usuarios/UsuariosConfig';
import MapaSitiosConfig from "../main/mapaSitios/MapaSitiosConfig";
import GraficasDesempenoConfig from "../main/graficasDesempeno/GraficasDesempenoConfig";

const routeConfigs = [
  DashboardConfig,
  SignOutConfig,
  SignInConfig,
  SignUpConfig,
  MesaServicioConfig,
  MesaServicioReportesConfig,
  MonitoreoConfig,
  ReportesConfig,
  RepositorioConfig,
  NivelesServicioConfig,
  CreateDocumentConfig,
  TopologicaConfig,
  InterconectadosConfig,
  AutoDescubrimientoConfig,
  AdministracionConfig,
  TicketsConfig,
  TiposConsumoConfig,
  NodosConfig,
  SitiosConfig,
  EntidadConfig,
  TipoInmuebleConfig,
  RegionConfig,
  GrupoInmuebleConfig,
  InmuebleConfig,
  UmbralConfig,
  UsuariosConfig,
  MapaSitiosConfig,
  GraficasDesempenoConfig
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  {
    path: '/',
    element: <Navigate to="/dashboard" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/mesa" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/mesa_reportes" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/monitoreo" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/topologica" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/interconectados" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/autodescubrimiento" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/administracion" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/estadisticas" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/reportes" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/tiposConsumo" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/sitios" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/nodos" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/entidad" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/tipoInmueble" />,
    auth: settingsConfig.defaultAuth,
  },

  {
    path: '/',
    element: <Navigate to="/region" />,
    auth: settingsConfig.defaultAuth,
  },

  {
    path: '/',
    element: <Navigate to="/grupoInmueble" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/inmueble" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/umbral" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/usuarios" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: '/',
    element: <Navigate to="/repositorio" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
  },
  {
    path: 'dashboard',
    element: <Dashboard />,
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" />,
  },
  {
    path: 'create_document',
    element: <CreateDocument />,
  },
];

export default routes;
